import { Chip, Stack, Typography } from "@mui/material";

const ChangeTextChip = ({ newValue, newChip, oldValue, oldChip }) => {
  if (newValue === oldValue && newChip === oldChip) {
    return (
      <Typography variant="body2">
        {newValue}
        {newChip && (
          <Chip
            size="small"
            label={newChip}
            sx={{ ml: 1 }}
            variant="outlined"
          />
        )}
      </Typography>
    );
  }
  return (
    <Stack spacing={0.5}>
      {/* New value */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: "bold",
          color: "orange",
        }}
      >
        {newValue}
        {newChip && (
          <Chip
            size="small"
            label={newChip}
            sx={{ ml: 1, fontWeight: "bold", color: "orange" }}
            variant="outlined"
          />
        )}
      </Typography>

      {/* Old value */}
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          textDecoration: "line-through",
          fontWeight: "bold",
        }}
      >
        {oldValue}
        {oldChip && (
          <Chip
            size="small"
            label={oldChip}
            sx={{
              ml: 1,
              fontWeight: "bold",
              color: "text.secondary",
              textDecoration: "line-through",
            }}
            variant="outlined"
          />
        )}
      </Typography>
    </Stack>
  );
};

export default ChangeTextChip;
